//  ========================================================================= orginal(encrypt&&decrypt) =====================================
import { Emitter } from "./eventEmiter";
import AllGamesres39 from "../../../assets/Allgamejson39.json"

const crypto = require('crypto');

export default class servicConnect {
    constructor(props) {
        this.ConnectionEstd = "onConnectionEstablished";
        this.OnReceivingData = "OnReceivingData";
        this.ConnectionClosed = "onConnectionClosed";
        this.ReceiveNoConnection = "ReceiveNoConnection";
        this.webSocketClosed = "webSocketClosed";
        this.saltKey = "";
        this.ivkey = "";
        this.myGameId = "";
        this.mySiteId = "";
        this.myLang = "";
        this.playerId = "";
        this.myPlayerToken = "";
        this.AllGameResJson = AllGamesres39;
        this.isDummyConnection = false;
        this.isTruco = true;
        this.isEncoded = false;
        this.sendof = this.sendof.bind(this)
    }
    connection() {
        this.myGameId = sessionStorage.getItem("gameId");
        this.mySiteId = sessionStorage.getItem("siteId");
        this.myLang = sessionStorage.getItem("lang");
        this.playerId = sessionStorage.getItem("playerId");
        let DomainUrl = window.location.hostname
        if (this.myLang == null) {
            this.myLang = "en";
        }
        if (this.isDummyConnection) {
            this.DummyWebsocketConnection(this.isTruco)
        } else {
            this.myPlayerToken = sessionStorage.getItem("playerToken");
            if (process.env.REACT_APP_IS_PRODUCTION === "false") {

                if (this.isTruco) {
                    // this._connection = new WebSocket(`ws://10.10.20.65:8089/truco?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                    // this._connection = new WebSocket(`ws://10.10.20.58:8099/truco?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                    // this._connection = new WebSocket(`ws://10.10.20.58:8089/truco?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                    // this._connection = new WebSocket(`ws://10.10.20.201:8089/ws?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                    this._connection = new WebSocket(`wss://truco.prep4.live/ws?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                } else {
                    this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games`);  //Development
                    //  this._connection = new WebSocket(`wss:///live.ballagames.com/ws/games`);  //Development
                    // this._connection = new WebSocket(`wss://ballagames.prep4.live/ws/games`);  //Stagings

                    // this._connection = new WebSocket(`ws://10.10.20.25:8994/ws/games`); // kalyani
                    // this._connection = new WebSocket(`ws://10.10.20.34:8987/ws/games`); // sowmya 
                }
            } else {
                // this._connection = new WebSocket(`ws://10.10.20.58:8089/truco?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                // this._connection = new WebSocket(`wss://${DomainUrl}/ws/games`);
                // this._connection = new WebSocket(`ws://10.10.20.201:8089/truco?lang=${this.myLang}&playerId=${this.playerId}`);  //Development
                this._connection = new WebSocket(`wss://${DomainUrl}/ws?lang=${this.myLang}&playerId=${this.playerId}`);

            }

            this._connection.addEventListener('open', this.connectEventHandler.bind(this));
            this._connection.addEventListener('close', this.closeEventHandler.bind(this));
            this._connection.addEventListener('error', this.errorEventHandler.bind(this));
            this._connection.addEventListener('message', this.dataEventHandler.bind(this));

        }
    }


    setKeyValues(wsid, ivVal) {
        this.saltKey = wsid;
        this.ivkey = ivVal;

        let body = {
            CN: "INIT_GAME",
            object: {
                gameId: this.myGameId,
                playerToken: this.myPlayerToken,
                site: this.mySiteId,
            },
            sessionId: ""
        }
        this.sendof(body)
    }

    connectEventHandler(event) {
        Emitter.emit(this.ConnectionEstd, event);
    }

    closeEventHandler(event) {
        Emitter.emit(this.webSocketClosed, event);
    }
    errorEventHandler(event) {
        Emitter.emit(this.ReceiveNoConnection, event);
    }

    dataEventHandler(event) {

        if (event.data.split(":")[0] == "wsession") {
            let myWs = JSON.parse(this.decrypt(event.data.split(": ")[1], process.env.REACT_APP_SALT, process.env.REACT_APP_KEY));
            this.separateEvery3rd(myWs.wsessionId)
        } else {
            let isJsonFormat;
            let data;
            try {
                JSON.parse(event.data);
                isJsonFormat = true;
            } catch (e) {
                isJsonFormat = false;
            }
            try {

                if (isJsonFormat) {
                    if (typeof event.data === "string" && event.data.trim().startsWith("{")) {
                        data = JSON.parse(event.data);
                    } else {
                        console.error("Invalid JSON format:", event.data);
                    }
                } else {
                    const decryptedText = this.decrypt(event.data, this.saltKey, this.ivkey);

                    if (typeof decryptedText === "string" && decryptedText.trim().startsWith("{")) {
                        data = JSON.parse(decryptedText);
                    } else {
                        console.error("Invalid decrypted JSON:", decryptedText);
                    }
                }
            } catch (error) {
                console.error("JSON Parsing Error:", error);
            }

            setTimeout(() => {
                console.log("Respose from server: ", data);
                Emitter.emit(this.OnReceivingData, data);
            }, 100)
        }
    }

    sendof(body) {
        let data = JSON.stringify(body);
        console.log("Request from Client: ", body)
        if (this.isDummyConnection) {
            this.onMessage(data)
        } else {
            if (this._connection.readyState == 1) {
                let cipherText
                if (this.isEncoded) {
                    cipherText = this.encrypt(data, this.saltKey, this.ivkey);
                } else {
                    cipherText = data
                }
                this._connection.send(cipherText);
            } else {
                console.log('WebSocket connection closed')
                if (window.confirm("WebSocket connection closed.Press Ok to refresh")) {
                    localStorage.clear()
                    window.location.reload()
                }
            }
        }
    }


    encrypt(plainText, key, iv2) {
        const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), iv2); // Use 'aes-128-cbc' for AES-128
        let encrypted = cipher.update(plainText, 'utf-8', 'base64');
        encrypted += cipher.final('base64');
        return encrypted;
    }

    decrypt(cipherText, key, iv2) {
        cipherText = ":" + cipherText;
        const [iv, encryptedMessage] = cipherText.split(':').map(part => Buffer.from(part, 'base64'));
        const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), iv2);
        let decrypted = decipher.update(encryptedMessage);
        decrypted = Buffer.concat([decrypted, decipher.final()]);
        return decrypted.toString();
    }

    separateEvery3rd(inputString) {
        let sltVal = '';
        for (let i = 2; i < inputString.length; i += 3) {
            sltVal += inputString[i];
        }

        let wssId = '';
        for (let i = 0; i < inputString.length; i++) {
            if ((i + 1) % 3 !== 0) {
                wssId += inputString[i];
            }
        }
        this.setKeyValues(wssId, sltVal);
    }

    DummyWebsocketConnection(isTruco) {

        this._connection = {
            eventListeners: {},

            addEventListener: function (event, callback) {
                console.log(`Adding event listener for: ${event}`);
                this.eventListeners[event] = callback;
            },

            simulateOpen: function () {
                this.GameID = sessionStorage.getItem("gameId");
                this.SiteIdDM = sessionStorage.getItem("siteId");
                this.PlayerTokenDM = sessionStorage.getItem("playerToken");
                setTimeout(() => {
                    console.log(" Simulated WebSocket Opened");
                    if (this.eventListeners["open"]) {
                        this.eventListeners["open"]({
                            type: "open", currentTarget: {
                                url: `wss://gearupcasino.undertesting.com/ws?gameId=${this.GameID}&playerToken=${this.PlayerTokenDM}&site=${this.SiteIdDM}&lang=en`
                            }
                        });
                    }
                }, 1000);
            },

            simulateMessage: function () {
                setTimeout(() => {
                    console.log(" Simulated Message Received");

                    const simulatedMessage = isTruco ? AllGamesres39[4]["GAME_LOBBY"] : {
                        status: 200,
                        msg: "success",
                        data: {
                            sessionId: "9ec711cd03dc485cb34cfaed22050af6",
                            playerId: 142433122
                        }
                    };

                    if (this.eventListeners["message"]) {
                        this.eventListeners["message"]({
                            type: "message",
                            data: JSON.stringify(simulatedMessage)
                        });
                    }
                }, 2000);
            }
        };

        // Add listeners

        this._connection.addEventListener("open", (event) => {
            console.log(" WebSocket Opened:", event);
        });
        this._connection.addEventListener("message", (event) => {
            console.log("📩 WebSocket Message Received:", event);
        });

        this._connection.addEventListener('open', this.connectEventHandler.bind(this));
        this._connection.addEventListener('message', this.dataEventHandler.bind(this));

        // Manually trigger events
        this._connection.simulateOpen();
        this._connection.simulateMessage();

    }
    onMessage(data) {
        try {
            const request = JSON.parse(data);
            this.generateResponse(request);
        } catch (error) {
            console.error("Error processing message:", error);
        }
    }

    generateResponse(request) {
        let ResponseData = []; // Use `let` instead of `const`

        if (request.CN && request.object?.action) {
            ResponseData = this.AllGameResJson[request.object.gameId][request.object.action] || { error: "Action not found" };
        } else {
            if (request.CN === "INIT_GAME") {
                ResponseData = {
                    status: 200,
                    msg: "success",
                    data: {
                        sessionId: "9ec711cd03dc485cb34cfaed22050af6",
                        playerId: 142433122
                    }
                }
            } else if (request.type) {
                ResponseData = this.AllGameResJson[4][request.type]
                if (Array.isArray(ResponseData)) {
                    ResponseData.map(ele => {
                        console.log("Emitting Response:", ele);
                        Emitter.emit(this.OnReceivingData, ele)
                    })
                    return
                }

            }
            else {
                ResponseData = this.AllGameResJson[request.object.gameId][request.CN] || { error: "CN not found" };
            }
        }

        console.log("Emitting Response:", ResponseData);
        Emitter.emit(this.OnReceivingData, ResponseData);
    }
}

// ========================================================================= original(encrypt&&decrypt) ========================================